import { Component, Input } from '@angular/core';
import { Route } from 'src/app/models/route';
import { Profile } from 'src/app/models/profile';
import { isCompanyRouteOwner, isMyRoute, isProfessionalRouteOwner } from 'src/app/utils/route';
import { PROFILE_TYPE, TRAVEL_STATUS } from 'src/app/constants';

@Component({
  selector: 'route-state',
  templateUrl: './route-state.component.html',
  styleUrls: ['./route-state.component.scss'],
})
export class RouteStateComponent {

  @Input() route: Route;
  @Input() profile: Profile;
  @Input() fromRouteDetailPage: boolean;

  professionalActor: PROFILE_TYPE = PROFILE_TYPE.professional;
  companyActor: PROFILE_TYPE = PROFILE_TYPE.company;

  constructor() {}

  isMyRoute() {
    return isMyRoute(this.route, this.profile);
  }

  isProfessionalRouteOwner(): boolean {
    return isProfessionalRouteOwner(this.route);
  }

  isCompanyRouteOwner(): boolean {
    return isCompanyRouteOwner(this.route);
  }
  
  get activeTravel() {
    const { travels = [] } = this.route;
    const travel = travels.find(({ travelStatus }) => {
      const activeStatus = [TRAVEL_STATUS.waiting_pickup, TRAVEL_STATUS.in_transit, TRAVEL_STATUS.delivered];
      return activeStatus.includes(travelStatus);
    });

    return travel;
    // if(this.isMyRoute() || travel.actor.id === this.profile.id) {
    //   return travel;
    // } else {
    //   return null;
    // }
  }

  getSoftArchivedRouteOrTravel() {
    const { travels = [] } = this.route;
    
    const travel = travels.find(({ travelStatus }) => {
      const activeStatus = [TRAVEL_STATUS.idle];
      return activeStatus.includes(travelStatus);
    }) || {};
    
    const isRouteArchived = this.route.softDeleted || false;
    const isTravelArchived = travel.softDeleted || false;

    return isRouteArchived || isTravelArchived;
  }

  getOtherProfile() {
    if (isMyRoute(this.route, this.profile)) {
      const { actor = {} as Profile } = this.activeTravel || {};
      return actor;
    }
    
    const { owner = {} as Profile } = this.route;
    return owner;
  }

  getOtherRoleType() {
    const profile = this.getOtherProfile();
    if (profile && profile.type) {
      return profile.type;
    }

    return '';
  }
}
